import { render, staticRenderFns } from "./outFrame.vue?vue&type=template&id=42abbe46"
import script from "./outFrame.vue?vue&type=script&lang=js"
export * from "./outFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports